import { createContext, useContext } from 'react';

const PermissionsContext = createContext(null);

const usePermissions = () => useContext(PermissionsContext);

export { PermissionsContext, usePermissions };